import { ComponentChildren, h } from 'preact'
import { useAppState, useStore } from '../../../../lib/redux-provider-nohooks'
import { reloadResultat } from '../../../store/actions'

import styles from './AppFrame.css'
import { Profil } from '../../shared/Decoration'

type Props = {
  children: ComponentChildren
}

export function AppFrame(props: Props) {
  const { kommuneresultat, fylkesresultat } = useAppState()
  const isReloading = kommuneresultat.state === 'reloading' || fylkesresultat.state === 'reloading'
  const store = useStore()
  function handleClick() {
    store.dispatch(reloadResultat())
  }

  return (
    <div class={styles.appFrame}>
      <div class={styles.appBanner}>
        <Profil id={`banner`} class={styles.appProfil} />
      </div>
      <div>{props.children}</div>
    </div>
  )
}
